import CrudCustom from '../../../libs/custom/CrudCustom';

let DaftarNominatifEntertainmentService = new CrudCustom('/transaksi-beban-entertainments');
export default DaftarNominatifEntertainmentService;
